import {
  WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_NOT_OPENED,
  WORKFLOW_ACTIVITY_ACTION_ONE_ACTION,
  WORKFLOW_ACTIVITY_ACTION_SMS_EXPIRED,
  //
  //
  WORKFLOW_ACTIVITY_ACTION_SMS_NOT_DELIVERED,
  WORKFLOW_ACTIVITY_ACTION_SMS_REJECTED,
  WORKFLOW_ACTIVITY_ACTION_TEN_ACTION
} from 'Constants/'
import {
  Flex,
  FlexItem,
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputNumber,
  Text,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const activityTypesLastTime = [
  WORKFLOW_ACTIVITY_ACTION_NOT_OPENED,
  WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_ONE_ACTION,
  WORKFLOW_ACTIVITY_ACTION_TEN_ACTION,
  WORKFLOW_ACTIVITY_ACTION_SMS_NOT_DELIVERED,
  WORKFLOW_ACTIVITY_ACTION_SMS_REJECTED,
  WORKFLOW_ACTIVITY_ACTION_SMS_EXPIRED
]

const activityTypesMax15 = [
  WORKFLOW_ACTIVITY_ACTION_NOT_OPENED,
  WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED
]

const InputActivityValue = () => {
  const intl = useIntl()

  const { ActivityType, ActivityValue } = useRecoilValue(step2State)

  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const { labelDaysBefore, labelDaysAfter } = useMemo(() => {
    return activityTypesLastTime.includes(ActivityType)
      ? {
          labelDaysBefore: intl.formatMessage({
            id: 'Load.AutomationWorkflow.ActivityTimeLast'
          }),
          labelDaysAfter: intl.formatMessage({
            id: 'Load.AutomationWorkflow.ActivityTimeLastDay'
          })
        }
      : {
          labelDaysBefore: intl.formatMessage({
            id: 'Load.AutomationWorkflow.ActivityTime'
          }),
          labelDaysAfter: intl.formatMessage({
            id: 'Load.AutomationWorkflow.ActivityTimeDay'
          })
        }
  }, [ActivityType])

  const maxDays = useMemo(() => {
    return activityTypesMax15.includes(ActivityType) ? 15 : 90
  }, [ActivityType])

  const activityValueFeedback = useMemo(() => {
    return parseInt(ActivityValue) > maxDays
      ? intl.formatMessage(
          { id: 'Load.AutomationWorkflow.LastDayValidation' },
          {
            XGIORNI: maxDays
          }
        )
      : undefined
  }, [ActivityValue, ActivityType])

  const handleActivityValueChange = (value) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      ActivityValue: value
    }))
  }

  return (
    <>
      <Flex
        justifyContent='flex-start'
        alignItems='flex-start'
        columnGap='16px'
      >
        <FormElement
          feedback={
            !(ActivityValue >= 0 && ActivityValue <= maxDays) ||
            ActivityValue === null
              ? activityValueFeedback
              : undefined
          }
          feedbackVariant={
            !(ActivityValue >= 0 && ActivityValue <= maxDays) ||
            ActivityValue === null
              ? 'danger'
              : undefined
          }
        >
          <Flex columnGap='16px'>
            <FlexItem margin='8px 0 0 0'>
              <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
                {labelDaysBefore}
              </Text>
            </FlexItem>
            <Flex display='block' width='75px'>
              <InputNumber
                id='activityDays'
                min={0}
                max={maxDays}
                step={1}
                value={ActivityValue}
                onChange={handleActivityValueChange}
                variant={
                  !(ActivityValue >= 0 && ActivityValue <= maxDays) ||
                  ActivityValue === null
                    ? INPUT_TEXT_VARIANT_DANGER
                    : undefined
                }
              />
            </Flex>
            <FlexItem margin='8px 0 0 0'>
              <Text htmlElement='span'>{labelDaysAfter}</Text>
            </FlexItem>
          </Flex>
        </FormElement>
      </Flex>
    </>
  )
}

export default InputActivityValue
